import React from "react";
import DateHelper from "../../../DateHelper/DateHelper";

class NightAuditPresenterDate extends React.Component {
  constructor(props) {
    super(props)
  };

  render() {
    return (
      <div className="panel panel-default">
        <div className="panel-body">
          <h3 className="panel-heading-text">{I18n.t('post_date')}</h3>
          <div className="col-sm-4">
            {DateHelper.printDateToScreen(this.props.night_audit.post_date, this.props.date_format + ' ' + this.props.time_format)}
          </div>
        </div>
      </div>
    );
  }

  
};

export default NightAuditPresenterDate